/* ═══════════════════════════════════════════════════════════════════════════
   project-picker-search.js — ручной ввод в выпадашке «Все ЖК»: поиск по
   названию жилого комплекса. Префикс zpz-.

   Перенос черновика tools/.hero-draft/zadacha-poisk-zhk.js (20-21.08.2026).
   ⛔ Парного CSS у файла НЕТ, и это не упущение — см. ниже про теневое дерево.

   Владелец: «где блок все жк на странице сделай возможность писать руками тоже
   там в поимке». Это <project-picker> — Web Component со списком, но БЕЗ поля
   ввода: в Краснодаре 16 домов, в Москве их заметно больше, и листать глазами
   длинный столбец — не поиск.

   ⛔ ФАЙЛА КОМПОНЕНТА НЕ КАСАЕМСЯ. public/js/components/project-picker.js
      обслуживает не только витрину квартир; правка внутри него означала бы
      правку чужих страниц ради своей. Дополняем СНАРУЖИ: его теневое дерево
      открыто (attachShadow({ mode: 'open' })), поэтому поле и свои стили
      вставляются в ту же панель без единой правки чужого кода.

   ⛔⛔ ПОЧЕМУ НАБЛЮДАТЕЛЬ ВИСИТ НА САМОМ ТЕНЕВОМ ДЕРЕВЕ (правка 21.08.2026).
      Первая редакция одевала пикер один раз и уходила — на проде поля не было
      НИ В ОДНОМ кадре восьмисекундной съёмки, хотя код исполнялся без ошибок.
      Лента прода объяснила всё:

        268 мс  connectedCallback  — компонент нарисовал панель
        293 мс  панель = [zpz-find, list, zpz-none]   ← поле ВСТАВЛЕНО, всё верно
        312 мс  DOMContentLoaded
        313 мс  disconnectedCallback → connectedCallback
        316 мс  панель = [list]                        ← поле СТЁРТО

      По DOMContentLoaded просыпается flats-showcase.js и ПЕРЕНОСИТ живой узел
      `.flats-filter-group` с нашим `#filterBuilding` внутрь новой строки
      фильтра (`quick.appendChild(jkGroup)`). Перенос узла — это отключение и
      включение заново, то есть повторный connectedCallback, а тот делает
      `shadowRoot.innerHTML = …` и сносит панель вместе со всем, что мы в неё
      положили. Наш блок к этому моменту уже отработал и никого не сторожил.

      Вывод: сторожить надо НЕ появление пикера в светлом дереве и НЕ время, а
      САМО ТЕНЕВОЕ ДЕРЕВО. Объект shadowRoot переживает любые innerHTML и любые
      переносы узла (attachShadow зовётся один раз, в конструкторе), поэтому
      наблюдатель на нём — единственная точка, которая не может протухнуть.
      Сколько бы раз компонент себя ни перерисовал, панель одевается заново.

   ⛔ СВОЙ <style> ВНУТРЬ ТЕНЕВОГО ДЕРЕВА — НЕ ПРИХОТЬ, А ЕДИНСТВЕННЫЙ ПУТЬ.
      Теневое дерево на то и теневое: правила из обычного CSS-файла внутрь не
      достают. Положи мы их в public/css/*.css — класс проставился бы, а вида
      не было бы вовсе. Переменные палитры при этом наследуются как обычно,
      поэтому цвета берём из неё, а не зашиваем.

   Ищем по вхождению без учёта регистра, приставку «ЖК», кавычки и «ё» при
   сравнении отбрасываем: человек набирает «теплые», а в списке «ЖК «Тёплые
   края»». Строку сброса («Все ЖК») из выдачи не прячем — она не результат
   поиска, а способ отменить выбор, и терять её при наборе некуда.

   ⛔ НАЗВАНИЯ ПРИХОДЯТ ИЗ ФИДОВ — ИСТОЧНИК НЕДОВЕРЕННЫЙ. Ни одной сборки
      разметки строкой: только createElement и textContent.
   ═══════════════════════════════════════════════════════════════════════════ */
(() => {
  'use strict';

  if (window.__broniPickerSearch) return;
  window.__broniPickerSearch = true;

  /* ⛔ Документ держим ССЫЛКОЙ, а не через глобальное имя. Наблюдатели живут
     дольше кода, который их поставил, и обязаны пережить момент, когда
     глобального `document` под ними уже нет (в jsdom при закрытии окна имя
     обнуляется, и наблюдатель падал уже после конца теста). */
  const DOC = document;

  const norm = (s) => String(s || '')
    .toLowerCase()
    .replace(/[«»"']/g, '')
    .replace(/^жк\s+/, '')
    .replace(/ё/g, 'е')
    .trim();

  const STYLE_ID = 'zpz-style';

  /* ⛔ Запасных значений у переменных НЕТ НАМЕРЕННО. В черновике стояло
     `var(--border, rgba(255,255,255,.08))`, `var(--dark3, rgba(255,255,255,.04))`
     и так далее — а запасное значение это РАБОЧИЙ цвет, если переменной не
     окажется. Здесь они разошлись бы с палитрой в четырёх местах из пяти
     (настоящий --border это rgba(200,169,110,.2), а не белый), то есть поле
     тихо стало бы другого цвета и никто бы не понял почему. Все пять
     переменных объявлены в main.css — тест это и сверяет. */
  const CSS = [
    '.zpz-find{position:relative;margin:0 0 8px}',
    '.zpz-find input{width:100%;min-height:38px;padding:8px 30px 8px 32px;',
    'border:1px solid var(--border);border-radius:9px;',
    'background:var(--dark3);color:var(--text);',
    'font-family:var(--font-body);font-size:14px;outline:none;',
    'transition:border-color .2s,background .2s}',
    '.zpz-find input::placeholder{color:var(--text-dim)}',
    '.zpz-find input:focus{border-color:var(--gold);background:rgba(255,255,255,.07)}',
    '.zpz-ico{position:absolute;left:11px;top:50%;transform:translateY(-50%);',
    'font-size:12px;color:var(--text-dim);pointer-events:none}',
    '.zpz-clear{position:absolute;right:6px;top:50%;transform:translateY(-50%);',
    'width:22px;height:22px;display:none;align-items:center;justify-content:center;',
    'border:0;border-radius:50%;background:transparent;color:var(--text-dim);',
    'font-size:12px;cursor:pointer}',
    '.zpz-clear:hover{color:var(--text);background:rgba(255,255,255,.08)}',
    '.zpz-find.zpz-has .zpz-clear{display:flex}',
    '.zpz-none{display:none;padding:14px 10px;text-align:center;font-size:13px;',
    'color:var(--text-dim);font-family:var(--font-body)}',
    '.zpz-none.zpz-on{display:block}',
    /* ⛔ У .opt в стилях компонента стоит display:flex, а браузерное
       [hidden]{display:none} слабее класса — без своей строки спрятать вариант
       атрибутом невозможно, и поиск ничего бы не отсеивал. */
    '.opt[hidden]{display:none}',
    /* ⛔ Панель была ровно по ширине кнопки (210 px), и половина названий
       обрезалась многоточием: «ЖК «Самоле…», «ЖК «Тепл…». Пока список листали
       глазами, это терпели; с поиском обрезка стала мешать прямо — человек
       набирает и не видит, что нашлось. Расширяем только на компьютере: до
       768 px у компонента своё правило (панель во всю ширину поля), и общий
       min-width там вытолкнул бы её за край экрана. */
    '@media (min-width:769px){.panel{min-width:330px}}',
  ].join('');

  /* ═══ ФИЛЬТРАЦИЯ ═══
     ⛔ Узлы ищем от shadowRoot КАЖДЫЙ РАЗ, а не держим в замыкании. После
     повторного connectedCallback и `.list`, и панель — уже ДРУГИЕ объекты;
     замыкание указывало бы на выброшенные узлы и молча ничего не делало. */
  function applyFilter(host) {
    const sr = host.shadowRoot;
    if (!sr) return;
    const input = sr.getElementById('zpzFind');
    const list = sr.getElementById('list');
    if (!input || !list) return;
    const wrap = sr.querySelector('.zpz-find');
    const none = sr.querySelector('.zpz-none');

    const q = norm(input.value);
    if (wrap) wrap.classList.toggle('zpz-has', input.value !== '');
    let found = 0;
    list.querySelectorAll('.opt').forEach((opt) => {
      const id = opt.dataset.project || '';
      if (id === '') { opt.hidden = false; return; }
      const nameNode = opt.querySelector('.opt__name');
      const name = norm(nameNode ? nameNode.textContent : '');
      const hit = !q || name.indexOf(q) !== -1;
      opt.hidden = !hit;
      if (hit) found++;
    });
    if (none) none.classList.toggle('zpz-on', q !== '' && found === 0);
  }

  /**
   * Одевает панель: свой <style>, поле, крестик, заглушка «ничего не нашлось».
   * Идемпотентна — повторный вызов на уже одетой панели ничего не делает.
   * @returns {boolean} панель одета (или была одета раньше)
   */
  function dressUp(host) {
    const sr = host.shadowRoot;
    if (!sr) return false;
    const panel = sr.querySelector('.panel');
    const list = sr.getElementById('list');
    if (!panel || !list) return false;
    if (sr.getElementById('zpzFind')) return true;

    if (!sr.getElementById(STYLE_ID)) {
      const st = DOC.createElement('style');
      st.id = STYLE_ID;
      st.textContent = CSS;
      sr.appendChild(st);
    }

    const wrap = DOC.createElement('div');
    wrap.className = 'zpz-find';

    const ico = DOC.createElement('i');
    ico.className = 'zpz-ico fa-solid fa-magnifying-glass';
    ico.setAttribute('aria-hidden', 'true');

    const input = DOC.createElement('input');
    input.type = 'text';
    input.id = 'zpzFind';
    input.placeholder = 'Найти жилой комплекс';
    input.autocomplete = 'off';
    input.setAttribute('aria-label', 'Поиск жилого комплекса');

    const clear = DOC.createElement('button');
    clear.type = 'button';
    clear.className = 'zpz-clear';
    clear.setAttribute('aria-label', 'Очистить');
    const clearIco = DOC.createElement('i');
    clearIco.className = 'fa-solid fa-xmark';
    clearIco.setAttribute('aria-hidden', 'true');
    clear.appendChild(clearIco);

    wrap.appendChild(ico);
    wrap.appendChild(input);
    wrap.appendChild(clear);

    const none = DOC.createElement('div');
    none.className = 'zpz-none';
    none.textContent = 'Ничего не нашлось';

    panel.insertBefore(wrap, list);
    // ⛔ Заглушка «ничего не нашлось» ЛЕЖИТ ВНЕ .list. Положи мы её внутрь —
    //    наблюдатель за списком увидел бы собственную запись и позвал бы сам
    //    себя. Такая петля уже вешала страницу на другом черновике.
    panel.appendChild(none);

    input.addEventListener('input', () => applyFilter(host));
    input.addEventListener('click', (e) => e.stopPropagation());
    // Ввод по единственному найденному — выбираем его: набрал три буквы и нажал
    // ввод, не целясь мышью.
    input.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter') return;
      const vis = Array.prototype.filter.call(
        list.querySelectorAll('.opt'),
        (o) => !o.hidden && (o.dataset.project || '') !== ''
      );
      if (vis.length === 1) { e.preventDefault(); vis[0].click(); }
    });
    clear.addEventListener('click', (e) => {
      e.stopPropagation();
      input.value = '';
      applyFilter(host);
      input.focus();
    });

    // Список наполняется ПОСЛЕ ответа сервера и перерисовывается целиком
    // (`list.innerHTML = …`) при каждой смене города. Наблюдаем за самим
    // списком и накладываем фильтр заново. Своих узлов в .list не добавляем —
    // только прячем чужие, поэтому наблюдатель не может увидеть свою работу.
    // Узел `.list` живёт ровно до следующей перерисовки панели; вместе с ним
    // уходит и этот наблюдатель, а новый ставится следующим dressUp.
    new MutationObserver(() => applyFilter(host)).observe(list, { childList: true });

    applyFilter(host);
    return true;
  }

  /* ═══ ПОСТОЯННЫЕ НАБЛЮДАТЕЛИ — ПО ОДНОМУ КОМПЛЕКТУ НА ПИКЕР ═══ */
  const watched = new WeakSet();

  /**
   * Подписывается на теневое дерево пикера НАВСЕГДА и одевает панель.
   * @returns {boolean} подписка состоялась (пикер поднят, дерево есть)
   */
  function attach(host) {
    const sr = host.shadowRoot;
    // Элемент ещё не поднят кастом-элементами — теневого дерева нет.
    if (!sr) return false;
    if (watched.has(host)) { dressUp(host); return true; }
    watched.add(host);

    /* ⛔ ГЛАВНЫЙ СТОРОЖ. Компонент рисует себя целиком (`shadowRoot.innerHTML=…`)
       в каждом connectedCallback, а тот случается при КАЖДОМ переносе узла —
       и по DOMContentLoaded такой перенос делает flats-showcase.js. Объект
       shadowRoot при этом остаётся тем же, поэтому наблюдатель на нём не
       протухает никогда и одевает панель заново столько раз, сколько нужно.
       Дёргается он только на перерисовках самого компонента (единицы за
       жизнь страницы), а не на перерисовках выдачи. */
    new MutationObserver(() => { dressUp(host); }).observe(sr, { childList: true });

    // Панель открылась — строка поиска пуста и в фокусе. ВЫБОР при этом не
    // сбрасываем: очищается строка поиска, а не выбранный ЖК.
    new MutationObserver(() => {
      if (!host.hasAttribute('data-open')) return;
      const sr2 = host.shadowRoot;
      const input = sr2 && sr2.getElementById('zpzFind');
      if (!input) return;
      input.value = '';
      applyFilter(host);
      // Фокус — следующим кадром: на телефоне мгновенный фокус поднимает
      // клавиатуру раньше, чем панель успевает встать на место.
      window.requestAnimationFrame(() => {
        try { input.focus({ preventScroll: true }); } catch (err) { input.focus(); }
      });
    }).observe(host, { attributes: true, attributeFilter: ['data-open'] });

    dressUp(host);
    return true;
  }

  /** @returns {boolean} хотя бы один пикер найден И подписан */
  const attachAll = () => {
    const all = DOC.querySelectorAll('project-picker');
    if (!all.length) return false;
    let any = false;
    all.forEach((el) => { if (attach(el)) any = true; });
    return any;
  };

  /* ⛔ ПОСТОЯННОГО НАБЛЮДАТЕЛЯ ЗА ВСЕМ ДОКУМЕНТОМ ЗДЕСЬ НЕТ, И ЭТО ПРАВКА
     ЧЕРНОВИКА. Там стоял `observe(document.documentElement, {subtree:true})`
     НАВСЕГДА — он дёргался на каждой перерисовке выдачи (65 карточек на
     фильтр) и каждый раз обходил документ в поисках пикера, которого там
     давно нет. Сам элемент стоит в шаблоне и не пересоздаётся ни разу; он
     лишь ПЕРЕЕЗЖАЕТ, а переезд не меняет ни узел, ни его теневое дерево —
     за перерисовками следит наблюдатель на shadowRoot, поставленный выше.
     Здешний наблюдатель нужен ровно для одного: ДОЖДАТЬСЯ пикера, если тот
     доедет позже. Снимается по факту находки, а не по таймеру. */
  const start = () => {
    if (attachAll()) return;
    if (window.customElements && window.customElements.whenDefined) {
      window.customElements.whenDefined('project-picker')
        .then(() => { window.setTimeout(attachAll, 0); })
        .catch(() => {});
    }
    // Пикер может доехать позже: секцию фильтра перестраивает соседний блок.
    const zone = DOC.querySelector('.flats-filters-section') || DOC.body;
    const wait = new MutationObserver(() => { if (attachAll()) wait.disconnect(); });
    wait.observe(zone.parentNode || zone, { childList: true, subtree: true });
    // Две дешёвые контрольные точки: пикер мог подняться между проверками.
    DOC.addEventListener('DOMContentLoaded', () => { if (attachAll()) wait.disconnect(); });
    window.addEventListener('load', () => { if (attachAll()) wait.disconnect(); });
  };

  if (DOC.readyState === 'loading') {
    DOC.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
